import BarChart from './BarChart'
import TableComponent from './TableComponent'
import ProductTableComponent from './ProductsTableComponent'
import { useTheme, resolveCategoryColor } from '../../utils/theme'

const IndicatorRenderer = ({
  indicator,
  activeIndex,
  myIndex,
  currentCode,
  countryMap,
  compareMode,
  groupColor,
  groupCode,
  compareCountries = [],
  compareData = {},
  canDownload = true,
}) => {
  const { colors } = useTheme()

  if (!indicator) return null;

  const type = indicator.data?.type || 'bar'
  const baseValues = indicator.data?.values || []

  const labels = baseValues.map(d => d.dimension)

  const resolvedGroupColor = resolveCategoryColor(colors.groups, groupCode, groupColor)

  const series = [
    {
      name: countryMap[currentCode],
      values: baseValues.map(v => v.value),
      color: compareMode ? colors.chartSingleMode : resolvedGroupColor,
    },

    ...compareCountries.map((code, index) => {
      const countryData = compareData[code]

      const raw =
        countryData?.indicators_map?.[indicator.id]?.data?.values

      const values = Array.isArray(raw) ? raw : []

      return {
        name: countryMap[code],
        values: values.map(v => v.value),
        color: colors.chartComparisonMode,
      }
    })
  ]

  const chartData = { labels, series }

  switch (type) {
    case 'table':
      return <TableComponent data={baseValues} title={indicator.name} />

    case 'top_products':
      return (
        <ProductTableComponent
          data={baseValues}
          title={indicator.chart_title}
        />
      )

    case 'bar':
    default:
      return (
        <BarChart
          data={chartData}
          title={indicator.chart_title}
          activeIndex={activeIndex}
          myIndex={myIndex}
          canDownload={canDownload}
          indicatorId={indicator.id}
          countryCode={currentCode}
        />
      )
  }
}

export default IndicatorRenderer
